/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'NEW_WORKERS_WERE_HIRED_TO_REPLACE_STRIKING_WORKERS_DURING_INDUS',
              'WORKERS_WERE_PUNISHED_FOR_PARTICIPATING_IN_INDUSTRIAL_ACTIONS_S',
              'SECURITY_GUARDS_THE_POLICE_OR_ARMED_FORCES_WERE_CALLED_BY_THE_F',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    did_any_of_the_following_occur_during_or_after_industrial_actio: valueSchema,
  },
}
